import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Card, CardActionArea, CardContent, CardMedia, Grid, Paper } from '@material-ui/core';
import placeHolderProdImage from '../../prod.png';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    fontFamily: "'SairaCF', 'Saira', Arial",
    fontWeight: 700,
    color: 'rgba(34, 34, 34, 1)',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography className={classes.root} variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  dividers: {
    border: 0
  }
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomDialog({ handleClose, open, variations, setCartridgeCallback }) {

  const variationsList = variations && variations.map((entry) => {
    console.log('The Dialog entry', entry);
    return (
      <div
        
        className="variation-box"
        key={entry.id}
        onClick={() => {
          setCartridgeCallback(entry)
          handleClose()
      }}>
        <div className="Content">
          <img src={entry.image ? entry.image : placeHolderProdImage} className="product-image" />
          
          <div className="product-name">
            <div className={`product-name`}>{entry.model}</div>
          </div>
        </div>
        <div className="BottomTriangle">
          <div className="Border"></div>
        </div>
      </div>
     )
  });

  return (
    <Dialog
      className="dialog-box"
      classes={{ paper: "dialog-box"}}
      BackdropProps={{ style: { backgroundColor: "rgba(255, 255, 0, 1)", opacity: 0.69 } }}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>Wähle dein Modell / Kartusche</DialogTitle>
      <DialogContent>
        <Grid container direction="row" alignItems="center" justifyContent="center">
          
          {variationsList}

        </Grid>
      </DialogContent>
    </Dialog>
  );
}
